import { create } from "zustand";
import { devtools } from "zustand/middleware";

/**
 * 워크스페이스 컨텍스트 전역 상태
 *
 * tenant-store.ts에서 workspace-store.ts로 전환:
 * - 테넌트(company) 컨텍스트는 Keycloak 인증 시 결정
 * - 워크스페이스는 사용자가 선택 (/:workspace 라우트 파라미터)
 * - API 호출 시 워크스페이스 slug를 헤더/경로에 포함시켜 데이터 격리
 */

export interface WorkspaceInfo {
  id: string;
  slug: string;
  name: string;
  /** 활성화된 모듈 코드 목록 (company_modules 프로비저닝 기반) */
  enabledModules: string[];
  /** true=프로비저닝 구성 완료(enabledModules 필터 적용), false=미구성(전체 노출) */
  modulesProvisioned: boolean;
  /** GxP 정책 설정 */
  gxpPolicy: {
    esignRequired: boolean;
    auditTrailRetentionYears: number;
  };
}

interface WorkspaceStore {
  workspace: WorkspaceInfo | null;
  setWorkspace: (workspace: WorkspaceInfo | null) => void;
  isModuleEnabled: (moduleCode: string) => boolean;
}

export const useWorkspaceStore = create<WorkspaceStore>()(
  devtools(
    (set, get) => ({
      workspace: null,
      setWorkspace: (workspace) => set({ workspace }, false, "setWorkspace"),
      isModuleEnabled: (moduleCode: string) => {
        const { workspace } = get();
        if (!workspace) return false;
        if (!workspace.modulesProvisioned) return true;
        return workspace.enabledModules.includes(moduleCode);
      },
    }),
    { name: "eqms/workspace" },
  ),
);
